// ANCHOR React
import React from 'react';

// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Styles
import { BLOCK, HOME_BLOCK, ROW_BLOCK } from './styles';

interface IProps {
  children: React.ReactNode;
  fromHomePage?: boolean;
  layout?: 'row' | 'column';
}

export const LyonContentCards = ({
  children, fromHomePage = false, layout = 'column',
}: IProps) => {
  if (layout === 'column') {
    return (
      <Block overrides={fromHomePage ? HOME_BLOCK : BLOCK}>
        { children }
      </Block>
    );
  }

  return (
    <Block overrides={ROW_BLOCK}>
      { children }
    </Block>
  );
};
